export const USER_CONSTRAINTS = {
  SET_USER_SESSION: "SET_USER_SESSION",
  GET_USER_SESSION: "GET_USER_SESSION",
  FAIL_USER_SESSION: "FAIL_USER_SESSION",
  SET_USER_PROFILE: "SET_USER_PROFILE",
  SET_LOADING: "SET_LOADING",
  SET_PROFILE_NOTIFICATIONS: "SET_PROFILE_NOTIFICATIONS",
};
